import { GraphDataObject, GraphTableData, Segment } from '../../types';
import {
  returnMediaGraph,
  returnMediaSegment,
  returnMediaTable,
  returnSalesGraph,
  returnSalesSegments,
  returnSalesTable,
  returnShareGraph,
  returnShareSegment,
  returnShareTable,
  returnDCPSegment,
  returnDCPGraph,
  returnDCPTable
} from './helpers';

interface staticData {
  timeRange: string;
  data: Array<GraphTableData>;
}

interface EndpointsProps {
  [key: string]: {
    [key: string]: {
      endpoint: string;
      id: string;
      title: string;
      index: number;
    }[];
  };
}
interface HandleEndpoints {
  [key: string]: {
    [key: string]: (id: string, data: any) => Segment[] | GraphDataObject[];
  };
}

// TODO: remove when API data becoem available
export const staticTableData: staticData = {
  timeRange: 'Last 6 Months',
  data: []
};

export const endpoints: EndpointsProps = {
  sales: {
    segments: [
      { endpoint: '/atglance/sales/summary', id: 'netSales', title: 'Net Sales', index: 0 },
      { endpoint: '/summary/sales', id: 'summarySales', title: 'Summary Sales', index: 1 }
    ],
    graph: [
      { endpoint: '/details/graph/sales/net', id: 'netSales', title: 'Net Sales', index: 0 },
      { endpoint: '/salesdetails/graph/orderedrevenue', id: 'POS', title: 'POS', index: 1 },
      { endpoint: '/salesdetails/graph/glanceviews', id: 'glanceViewsSales', title: 'Glance Views', index: 2 },
      { endpoint: '/salesdetails/graph/conversionrate', id: 'conversionRate', title: 'Conversion Rate', index: 3 },
      { endpoint: '/salesdetails/graph/asp', id: 'ASP', title: 'ASP', index: 4 }
    ],
    grid: [
      { endpoint: '/details/grid/sales/net', id: 'netSales', title: 'Net Sales', index: 0 },
      { endpoint: '/salesdetails/grid/orderedrevenue', id: 'POS', title: 'POS', index: 1 },
      { endpoint: '/salesdetails/grid/glanceviews', id: 'glanceViewsSales', title: 'Glance Views', index: 2 },
      { endpoint: '/salesdetails/grid/conversionrate', id: 'conversionRate', title: 'Conversion Rate', index: 3 },
      { endpoint: '/salesdetails/grid/asp', id: 'ASP', title: 'ASP', index: 4 }
    ]
  },
  share: {
    segments: [
      { endpoint: '/summary/share/amazon', id: 'amazonShare', title: 'Amazon', index: 0 },
      {
        endpoint: '/summary/share/competitive/sales',
        id: 'competitiveShare',
        title: 'Competitive <br/> Sales',
        index: 1
      }
    ],
    graph: [
      { endpoint: '/details/graph/share/amazon', id: 'amazonShare', title: 'Amazon', index: 0 },
      {
        endpoint: '/details/graph/share/competitive',
        id: 'competitiveShare',
        title: 'Competitive <br/> Sales',
        index: 1
      }
    ],
    grid: [
      { endpoint: '/details/grid/share/amazon', id: 'amazonShare', title: 'Amazon', index: 0 },
      {
        endpoint: '/details/grid/share/competitive',
        id: 'competitiveShare',
        title: 'Competitive <br/> Sales',
        index: 1
      }
    ]
  },
  digitalcommercepenetration: {
    segments: [{ endpoint: '/summary/penetration', id: 'dcp', title: 'Digital Commerce Penetration', index: 0 }],
    graph: [{ endpoint: '/details/penetration/graph', id: 'dcp', title: 'Digital Commerce Penetration', index: 0 }],
    grid: [{ endpoint: '/details/penetration/grid', id: 'dcp', title: 'Digital Commerce Penetration', index: 0 }]
  },
  media: {
    segments: [{ endpoint: '/summary/media', id: 'summaryMedia', title: 'Summary Media', index: 0 }],
    graph: [
      { endpoint: '/media/graph/conversions', id: 'mediaConversions', title: 'Conversions', index: 2 },
      { endpoint: '/media/graph/clicks', id: 'mediaClicks', title: 'Clicks', index: 1 },
      { endpoint: '/media/graph/spgr', id: 'mediaSPGR', title: 'Spend as % of Gross Revenue', index: 0 },
      { endpoint: '/media/graph/cpa', id: 'mediaCPA', title: 'CPA', index: 3 },
      { endpoint: '/media/graph/aov', id: 'mediaAOV', title: 'AOV', index: 4 }
    ],
    grid: [
      { endpoint: '/media/grid/conversions', id: 'mediaConversions', title: 'Conversions', index: 2 },
      { endpoint: '/media/grid/clicks', id: 'mediaClicks', title: 'Clicks', index: 1 },
      { endpoint: '/media/grid/spgr', id: 'mediaSPGR', title: 'Spend as % of Gross Revenue', index: 0 },
      { endpoint: '/media/grid/cpa', id: 'mediaCPA', title: 'CPA', index: 3 },
      { endpoint: '/media/grid/aov', id: 'mediaAOV', title: 'AOV', index: 4 }
    ]
  }
};

export const handleFetchEndpoint: HandleEndpoints = {
  sales: {
    segments: (id, data) => returnSalesSegments(id, data),
    graphs: (id, data) => returnSalesGraph(id, data),
    grid: (id, data) => returnSalesTable(id, data)
  },
  share: {
    segments: (id, data) => returnShareSegment(id, data),
    graphs: (id, data) => returnShareGraph(id, data),
    grid: (id, data) => returnShareTable(id, data)
  },
  digitalcommercepenetration: {
    segments: (id, data) => returnDCPSegment(id, data),
    graphs: (id, data) => returnDCPGraph(id, data),
    grid: (id, data) => returnDCPTable(id, data)
  },
  media: {
    segments: (id, data) => returnMediaSegment(id, data),
    graphs: (id, data) => returnMediaGraph(id, data),
    grid: (id, data) => returnMediaTable(id, data)
  }
};
